<template>
  <dok-downdrop>
    <template v-slot:button>
      <div class="relative">
        <div
          style="
          width: 10px;
          height: 10px;
          background: #fd5b68;
          right: -2px;
          top: -2px;
        "
          class="absolute rounded-full"
        ></div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          id="body_1"
          width="24"
          height="24"
        >
          <g transform="matrix(1.333333 0 0 1.333333 0 0)">
            <g transform="matrix(1 0 0 1 0 0)"></g>
            <path
              transform="matrix(1 0 0 1 0 0)"
              d="M12.75 1.5L5.25 1.5C 4.422 1.5 3.75 2.172 3.75 3L3.75 3L3.75 15C 3.75 15.828 4.422 16.5 5.25 16.5L5.25 16.5L12.75 16.5C 13.578 16.5 14.25 15.828 14.25 15L14.25 15L14.25 3C 14.25 2.172 13.578 1.5 12.75 1.5z"
              stroke="#767676"
              stroke-width="2"
              stroke-linecap="round"
              fill="none"
            />
            <g transform="matrix(1 0 0 1 0 0)"></g>
            <path
              transform="matrix(1 0 0 1 0 0)"
              d="M9 13.5L9.008 13.5"
              stroke="#767676"
              stroke-width="2"
              stroke-linecap="round"
              fill="none"
            />
          </g>
        </svg>
      </div>
    </template>

    <template v-slot:content>
      <div class="flex flex-col gap-y-3 justify-between mb-6">
        <h3 class="text-xl font-EffraR text-blackedsidebar" v-if="false">
          Requests :
        </h3>
        <div
          class="border-2 border-solid border-gray-300 rounded-lg p-3 flex flex-col gap-y-4"
        >
          <div class="flex flex-row items-start gap-x-3">
            <img src="/svg/dangercons.svg" />
            <div class="flex flex-col gap-y-1">
              <div class="flex flex-row gap-x-3" v-if="false">
                <div class="flex flex-row gap-x-2">
                  <img src="/svg/calendar_sm.svg" />
                  <span class="font-EffraR text-base">12 Sept</span>
                </div>
                <div class="flex flex-row gap-x-2">
                  <img src="/svg/clock_sm.svg" />
                  <span class="font-EffraR text-base">12:00</span>
                </div>
              </div>
              <div id="fullname" class="text-lg font-EffraM">
                Vérifier votre numéro de téléphone
              </div>
              <span class="font-EffraR text-sm">
                Complétez votre inscription en vérifiant votre numéro
              </span>
            </div>
          </div>

          <div class="flex justify-between">
            <div class="flex-1">
              <button
                @click="callVerification"
                class="flex flex-row items-center gap-x-1 bg-transparent border-0 text-green-600 font-EffraR text-base cursor-pointer"
              >
                <img src="/svg/check_green.svg" /> Vérifier mon numéro
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </dok-downdrop>
</template>

<script>
import { EventBus } from "@/event-bus";

export default {
  methods: {
    callVerification() {
      EventBus.$emit("Close_dropdown");
      EventBus.$emit("Call_Phone_Verification");
    }
  }
};
</script>

<style></style>
